import React, { useState } from "react";
import Button from "public/shared/ui/inputs/classicButton.js";
import { downloadFullSizeFiles, } from "./downloadFullSizeFiles.js";
import * as styles from "./FullSizeDownloadButton.module.css";
/**
 * Downloads the full size files of the given images,
 * more than one file is packed into a zip.
 * Render it only for groups with `containsFullSizeFiles`,
 * older groups do not store full size files.
 */
export default function FullSizeDownloadButton(props) {
    var _a;
    const { groupId, imageNames, zipName, onError } = props;
    const [progress, setProgress] = useState();
    async function download() {
        if (progress)
            return;
        setProgress({ done: 0, total: imageNames.length });
        const result = await downloadFullSizeFiles({
            groupId,
            imageNames,
            zipName,
            onProgress: setProgress,
        });
        setProgress(undefined);
        if (result.status === "no_full_size_files") {
            onError("Ta grupa nie zawiera plików w pełnym rozmiarze");
        }
        else if (result.status === "failed") {
            onError("Nie udało się pobrać plików w pełnym rozmiarze");
        }
    }
    return (React.createElement(Button, { version: "filled-tonal", disableExtraSpacing: true, onClick: download }, progress ?
        React.createElement("span", { className: styles.progress },
            "Pobieranie ",
            progress.done,
            "/",
            progress.total)
        : ((_a = props.label) !== null && _a !== void 0 ? _a : "Pobierz pełny rozmiar")));
}
